module.exports = __webpack_public_path__ + "static/img/J9-blue.ac1e837f.png";